export const renderExpiresInXDays = (expiresAt: string) => {
  const expiresAtDate = new Date(expiresAt);
  const today = new Date();
  const timeDiff = expiresAtDate.getTime() - today.getTime();
  const daysDiff = Math.ceil(timeDiff / (1000 * 3600 * 24));

  if (daysDiff <= 0) {
    return 'Last day to redeem!';
  }
  if (daysDiff === 1) {
    return `Expires in ${daysDiff} day`;
  }
  return `Expires in ${daysDiff} days`;
};
